
import React, { useState, useCallback, useEffect, useRef } from 'react';
import TerrainIcon      from '@mui/icons-material/Terrain';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import LayersIcon       from '@mui/icons-material/Layers';
import CloseIcon        from '@mui/icons-material/Close';
import './MapControlPanel.css';

const MapControlPanel = ({ mapRef }) => {
  const [open, setOpen]               = useState(false);
  const [terrainOn, setTerrainOn]     = useState(false);
  const [buildingsOn, setBuildingsOn] = useState(false);
  const rootRef = useRef(null);

  // Fermeture au clic en dehors du panneau
  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const handleToggleTerrain = useCallback(() => {
    const next = !terrainOn;
    setTerrainOn(next);
    mapRef?.current?.setTerrain?.(next, 1.5);
  }, [terrainOn, mapRef]);

  const handleToggleBuildings = useCallback(() => {
    const next = !buildingsOn;
    setBuildingsOn(next);
    mapRef?.current?.setBuildings3D?.(next);
  }, [buildingsOn, mapRef]);

  const activeCount = (terrainOn ? 1 : 0) + (buildingsOn ? 1 : 0);

  return (
    <div className={`mcp-root ${open ? 'mcp-root--open' : ''}`} ref={rootRef}>
      <div className="mcp-panel" role="menu">
        <div className="mcp-panel__header">
          <span className="mcp-panel__title">Vue 3D</span>
          <span className="mcp-panel__hint">Aperçu du terrain</span>
        </div>

        <button
          type="button"
          className={`mcp-row ${terrainOn ? 'mcp-row--active' : ''}`}
          onClick={handleToggleTerrain}
        >
          <span className="mcp-row__icon">
            <TerrainIcon style={{ fontSize: 15 }} />
          </span>
          <span className="mcp-row__text">
            <span className="mcp-row__label">Relief 3D</span>
            <span className="mcp-row__sub">Terrain exagéré</span>
          </span>
          <span className={`mcp-switch ${terrainOn ? 'mcp-switch--on' : ''}`}>
            <span className="mcp-switch__knob" />
          </span>
        </button>

        <button
          type="button"
          className={`mcp-row ${buildingsOn ? 'mcp-row--active' : ''}`}
          onClick={handleToggleBuildings}
        >
          <span className="mcp-row__icon">
            <LocationCityIcon style={{ fontSize: 15 }} />
          </span>
          <span className="mcp-row__text">
            <span className="mcp-row__label">Bâtiments 3D</span>
            <span className="mcp-row__sub">Extrusion des immeubles</span>
          </span>
          <span className={`mcp-switch ${buildingsOn ? 'mcp-switch--on' : ''}`}>
            <span className="mcp-switch__knob" />
          </span>
        </button>

        <div className="mcp-panel__footer">
          <span className={`mcp-footer-dot ${terrainOn ? 'mcp-footer-dot--on' : ''}`} />
          <span className={`mcp-footer-dot ${buildingsOn ? 'mcp-footer-dot--on' : ''}`} />
          <span className="mcp-footer-label">
            {activeCount === 0 ? 'Vue à plat' : activeCount === 1 ? '1 option active' : '2 options actives'}
          </span>
        </div>
      </div>

      <button
        type="button"
        className={`mcp-fab ${activeCount > 0 ? 'mcp-fab--active' : ''}`}
        onClick={() => setOpen((v) => !v)}
        title="Options de visualisation 3D"
      >
        <span className="mcp-fab__icon">
          {open ? <CloseIcon style={{ fontSize: 17 }} /> : <LayersIcon style={{ fontSize: 17 }} />}
        </span>
        {!open && activeCount > 0 && (
          <span className="mcp-fab__badge">{activeCount}</span>
        )}
      </button>
    </div>
  );
};

export default MapControlPanel;